import { TransactionFormValues, TransactionType } from "./types";

export const getTransactionInitialValues = (
  defaultType: TransactionType = "buy",
  defaults?: Partial<TransactionFormValues>,
): TransactionFormValues => ({
  type: defaultType,
  quantity: "",
  unitPrice: "",
  totalValue: "",
  currencyUuid: "",
  note: "",
  completedAt: "",
  file: null,
  ...defaults,
});
